/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Account} from '../models/Account';
import type {Error} from '../models/Error';

export interface GetAccountsByIds$Request {
    requestBody: Array<number>;
}

export interface GetAccountsByIds$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountsByIdsRequest = createAction<PayloadData<void, GetAccountsByIds$Request>>('GET_ACCOUNTS__GET_ACCOUNTS_BY_IDS__REQUEST');
export const getAccountsByIdsSuccess = createAction<PayloadData<{ [key: string]: Account; }, GetAccountsByIds$Request>>('GET_ACCOUNTS__GET_ACCOUNTS_BY_IDS__SUCCESS');
export const getAccountsByIdsFailure = createAction<PayloadData<Error, GetAccountsByIds$Request, true>>('GET_ACCOUNTS__GET_ACCOUNTS_BY_IDS__FAILURE');

export const getAccountsByIdsActions = [
    getAccountsByIdsRequest,
    getAccountsByIdsSuccess,
    getAccountsByIdsFailure
] as const;

/**
 * @param {Array<number>} meta.requestBody
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountsByIds = (meta: GetAccountsByIds$Request, config?: GetAccountsByIds$Config) => {
    return {
        CALL_API: {
            types: getAccountsByIdsActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/accounts/ids`,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

